"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePersonasDraftSchema = void 0;
var react_1 = require("react");
var personas_utils_1 = require("../utils/personas-utils");
var personas_change_detection_1 = require("../utils/personas-change-detection");
/**
 * Encapsulates the saved/draft schema state pattern shared by the
 * AI-Hub admin "categorized items" screens (Metrics and Personas).
 * Includes save/discard semantics and per-group / per-persona change
 * detection.
 */
exports.usePersonasDraftSchema = function (initialSchema) {
    var _a = react_1.useState(function () {
        return personas_utils_1.clonePersonasSchema(initialSchema);
    }), savedSchema = _a[0], setSavedSchema = _a[1];
    var _b = react_1.useState(function () {
        return personas_utils_1.clonePersonasSchema(initialSchema);
    }), draftSchema = _b[0], setDraftSchema = _b[1];
    var hasChanges = react_1.useMemo(function () { return !personas_utils_1.arePersonasSchemasEqual(draftSchema, savedSchema); }, [draftSchema, savedSchema]);
    var savedPropertyIndex = react_1.useMemo(function () { return personas_change_detection_1.buildSavedPropertyIndex(savedSchema); }, [savedSchema]);
    var updateDraft = react_1.useCallback(function (updater) {
        setDraftSchema(function (current) { return updater(personas_utils_1.clonePersonasSchema(current)); });
    }, []);
    var saveChanges = react_1.useCallback(function () {
        setDraftSchema(function (current) {
            var committed = personas_utils_1.clonePersonasSchema(current);
            setSavedSchema(committed);
            return personas_utils_1.clonePersonasSchema(committed);
        });
    }, []);
    var discardChanges = react_1.useCallback(function () {
        setDraftSchema(personas_utils_1.clonePersonasSchema(savedSchema));
    }, [savedSchema]);
    var isCategoryChanged = react_1.useCallback(function (categoryId) { return personas_change_detection_1.isCategoryChanged(categoryId, draftSchema, savedSchema); }, [draftSchema, savedSchema]);
    var isPropertyChanged = react_1.useCallback(function (property, categoryId) {
        return personas_change_detection_1.isPropertyChanged(property, categoryId, savedPropertyIndex);
    }, [savedPropertyIndex]);
    var findCategory = react_1.useCallback(function (categoryId) {
        return draftSchema.find(function (category) { return category.id === categoryId; }) || null;
    }, [draftSchema]);
    return {
        savedSchema: savedSchema,
        draftSchema: draftSchema,
        hasChanges: hasChanges,
        updateDraft: updateDraft,
        saveChanges: saveChanges,
        discardChanges: discardChanges,
        savedPropertyIndex: savedPropertyIndex,
        isCategoryChanged: isCategoryChanged,
        isPropertyChanged: isPropertyChanged,
        findCategory: findCategory,
    };
};
